<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :search-btn-hide="true"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:SettingLogisticsStrategyAssignGoodsIndex_Delete
            :disabled="tableOperationProp.notSelected"
            type="primary"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:SettingLogisticsStrategyAssignGoodsIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'amountStart'">
                {{ scope.row.amountStart }} ~ {{ scope.row.amountEnd }}
              </template>
              <template v-else-if="col.prop === 'enabledFlag'">
                <el-tag :type="scope.row[col.prop] ? 'success' : 'info'">{{
                  $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingLogisticsStrategyAssignGoodsIndex_Edit
                type="text"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="!props.row.enabledFlag"
                v-permission:SettingLogisticsStrategyAssignGoodsIndex_Status
                type="text"
                @click="onStatus(true, props.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-else
                v-permission:SettingLogisticsStrategyAssignGoodsIndex_Status
                type="text"
                @click="onStatus(false, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-permission:SettingLogisticsStrategyAssignGoodsIndex_Delete
                type="text"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
const getDefaultForm = () => {
  return {};
};
export default {
  name: 'SettingLogisticsStrategyAssignGoodsIndex',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      colSpan: 6,
      selection: false,
      queryApi: settingApi.getStrategyGoods, // settingApi.getStockProcess,
      // 查询参数
      queryParams: {
        spu: null,
      },
      title: '',
      dialogVisible: false,
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        // { label: 'goodsPage.spuCode', prop: 'spu', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false, width: 160 },
        { label: 'settingAssignGoods.table.price', prop: 'logisticCompanyName', isCheck: true, disabled: false, width: '160' },
        { label: 'settingAssignGoods.table.business', prop: 'logisticBusinessName', isCheck: true, disabled: false, width: '200' },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false},
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 135 },
        { label: 'settingAssignGoods.table.updater', prop: 'lastUpdatedName', isCheck: true, disabled: false, width: 135 },
        {
          label: 'settingAssignGoods.table.lastUpdater',
          prop: 'lastUpdateDate',
          isCheck: true,
          disabled: false,
          width: 135,
        },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 创建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    onEdit(row) {
      this.$refs.DataForm.show(row);
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_TRUE.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.spuName}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const data = this.$lodash.clone(row);
          data.enabledFlag = flag;
          this.operationApi(data);
        })
        .catch(() => {});
    },
    /** 删除 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.spuName}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.enabledFlag == true)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      settingApi.updateStrategyGoods(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      settingApi.deleteStrategyGoods(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
